import React from 'react'
import { LuTriangleAlert } from 'react-icons/lu'

import useAppSelector from '@/hooks/useAppSelector'
import { selectServiceAreas } from '@/redux/slices/commonData'
import { ReferralsImportItem } from '@/redux/slices/referralsImportBase'

interface Props {
  importItem: ReferralsImportItem
  afterBlockElement?: boolean
}

const ServiceMissingWarning: React.FC<Props> = ({
  importItem,
  afterBlockElement = false,
}) => {
  const serviceAreas = useAppSelector(selectServiceAreas())
  const selectedServiceArea = serviceAreas?.find(
    (serviceArea) => serviceArea.id === importItem.sourceServiceAreaId,
  )
  return (
    <>
      {!afterBlockElement && (
        <>
          ,<br />
        </>
      )}
      <span className="text-warning text-xs">
        <LuTriangleAlert className="mr-1 inline-block" />
        {selectedServiceArea && importItem.toCompany ? (
          <>
            you selected “
            <span className="font-semibold">{selectedServiceArea?.name}</span>
            ”, but this service is not provided by{' '}
            <span className="font-semibold">{importItem.toCompany.name}</span>,
            please select a different service or keep default
          </>
        ) : (
          <>please select service</>
        )}
      </span>
    </>
  )
}

export default ServiceMissingWarning
